import {useTranslation} from "react-i18next";
import {Card} from "antd";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import RequestLogGrid from "../../app/log/request-log-data-grid/RequestLogGrid";
import RequestLogFilter from "../../app/log/request-log-data-grid/RequestLogFilter";
import CardTitle from "../../core/components/CardTitle";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";

export default function RequestLogGridPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('System Logs')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            <DataGridProvider>
                <RequestLogGridContent />
            </DataGridProvider>
        </>
    )
}

function RequestLogGridContent() {
    const {t} = useTranslation();

    return (
        <LayoutWithSider
            fullWidth={true}
            sidebarTitle={t('Request Log Filter')}
            sidebarComponent={<RequestLogFilter />}
        >
            <Card title={<CardTitle title={t('System Logs')} />}>
                <RequestLogGrid />
            </Card>
        </LayoutWithSider>
    )
}
